export default __webpack_public_path__ + "static/media/valley7.1a7844de.png";